import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const CustomerSearchBar = ({ onSearch }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = (value) => {
    setSearchTerm(value);
    onSearch(value);
  };

  const clearSearch = () => {
    setSearchTerm('');
    onSearch('');
  };

  return (
    <div className="relative">
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <Icon name="Search" size={20} className="text-text-muted" />
        </div>
        <input
          type="text"
          placeholder="Buscar clientes por empresa, contacto o email..."
          value={searchTerm}
          onChange={(e) => handleSearch(e.target.value)}
          className="block w-full pl-10 pr-10 py-3 border border-border rounded-lg bg-surface text-text-primary placeholder-text-muted focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-micro"
        />
        {searchTerm && (
          <button
            onClick={clearSearch}
            className="absolute inset-y-0 right-0 pr-3 flex items-center text-text-muted hover:text-text-primary transition-micro"
          >
            <Icon name="X" size={18} />
          </button>
        )}
      </div>

      {/* Quick search suggestions */}
      <div className="mt-2 flex flex-wrap gap-2">
        <span className="text-xs text-text-muted">Búsquedas rápidas:</span>
        {['Activos', 'Premium', 'Madrid', 'Construcción'].map((suggestion) => (
          <button
            key={suggestion}
            onClick={() => handleSearch(suggestion)}
            className="inline-flex items-center px-2 py-1 text-xs font-body-medium text-text-secondary bg-secondary-50 hover:bg-secondary-100 rounded border border-secondary-200 transition-micro"
          >
            {suggestion}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CustomerSearchBar;